<script setup>
import { DateInput, DmIconButton, Dropdown, Icon, InputLabel, StringInput } from 'dmui_components'
import useReportTypeMgmt from '../composables/useReportTypeMgmt.js'
import Changelog from './Changelog.vue'

const { getReportTypes } = useReportTypeMgmt()

const props = defineProps({
	report: {
		type: Object,
		required: true
	},
	readOnly: {
		type: Boolean,
		default: false
	}
})

defineEmits(['update:report'])

function getFileNameFromUrl(sourceUrl) {
	try {
		const url = new URL(sourceUrl)
		return decodeURI(url.pathname?.split('/')?.pop())
	} catch {
		console.error('Invalid source URL')
		return ''
	}
}
</script>
<template>
	<div class="header-content">
		<h2 class="page-header">Report details</h2>
		<slot />
	</div>
	<div>
		<h3 class="primary-text bold">Changelog</h3>
		<Changelog :changelog="report?.changelog" :created-at="report?.created_at" />
	</div>
	<div class="details">
		<h3 class="primary-text bold">Report inputs</h3>
		<section class="bordered-content">
			<div>
				<InputLabel for="report-type">Type</InputLabel>
				<Dropdown
					id="report-type"
					:data="report.document_type"
					:options="getReportTypes(props.report.document_type)"
					:read-only="readOnly"
					size="small"
					@update:data="$emit('update:report', { ...report, document_type: $event })">
					<template #selected="{ data }">{{ data }} </template>
					<template #default="{ data }">{{ data }} </template>
				</Dropdown>
			</div>
			<div>
				<InputLabel for="report-year">Year</InputLabel>
				<StringInput id="report-year" :data="`${report.document_year}`" readonly />
			</div>

			<div>
				<InputLabel for="company">Company name</InputLabel>
				<StringInput id="company" :data="report?.org_name" readonly />
			</div>
		</section>
	</div>
	<div class="file-section">
		<span class="primary-text bold">Source document</span>
		<section class="bordered-content">
			<div>
				<Icon name="uil-file-check" size="midi" />
				<span class="secondary-text"> {{ getFileNameFromUrl(report?.source_url) }} </span>
			</div>

			<a v-if="report?.source_url" :href="report?.source_url" target="_blank">
				<DmIconButton id="download-button" class="primary transparent slim" icon="uil-download-alt" icon-size="midi"> Download </DmIconButton>
			</a>
		</section>
	</div>

	<div class="publication-date-section">
		<span class="primary-text bold"> Publication date </span>
		<section class="bordered-content">
			<DateInput id="publish-date" :data="report.published_at" placeholder="Publication date is not available" :disabled="true" />
		</section>
	</div>
</template>

<style scoped lang="less">
.details .bordered-content {
	display: flex;
	flex-direction: column;
	gap: @midi;
}
.file-section .bordered-content {
	display: flex;
	justify-content: space-between;
}
:deep(.dropdown) {
	width: 100%;
}
</style>
